export const tokenKey = "token";
export const customersKey = "customers";
export const productsKey = "products";
export const machineInfosKey = "MachineInfos";